import Immutable from 'immutable';

export const Panel = Immutable.Record(
  {
    id: null,
    name: null,
    width: 1,
    fullWidth: false,
    resizeToFit: false,
    isHeader: false,
    isRichText: false,
    descriptionUrl: null,
    height: 1,
    row: 0,
    column: 0,
    dashboardFilter: true,
    disabledFilters: false,
    release: null,
    showLegend: false,
    interactiveConfigurationSharedPanelUrl: null,
    type: null,
    bookmarkId: null,
    exampleReport: null,
    releasePermission: false,
    extensionIdentifier: null,
    exportName: null,
    settings: Immutable.Map(),
    bookmarkStartDate: null,
    bookmarkEndDate: null,
    useOriginal: false,
  },
  'Panel'
);
